import React, { useState, useEffect } from "react";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { Button, Table, Image, Form, Col, Modal, Row } from "react-bootstrap";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { NavLink, useHistory } from "react-router-dom";

import "react-circular-progressbar/dist/styles.css";
import { Menu, MenuItem } from "@material-ui/core";
// import UserModal from "./UserModal";
import BasicPagination from "../../../../Pagination/Pagination";

import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import Debounce from "../../../../../function/debounce";
import { amApi } from "../../../../../api/apiHelper";
import { errorAlert } from "../../../../../function/alert";
import { isEmpty } from "lodash";
import UserModal from "./UserModal";

const RetainedUsersList = (props) => {
  //state
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  //const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const [showFilter, setShowFilter] = useState(false);
  const [currentUserData, setCurrentUserData] = useState([]);
  const [profile, setProfile] = useState();
  const [startProfilePer, setStartProfilePer] = useState("");
  const [endProfilePer, setEndProfilePer] = useState("");
  const handleCloseEdit = () => setShowEdit(false);
  const [dateQuery, setDateQuery] = useState({});
  const [range, setRange] = useState('');
  const handleShowEdit = (user) => {
    setCurrentUserData(user);
    setShowEdit(true);
  };

  const [page, setPage] = useState(1);
  // var page = 1;

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    // var calcStart = pageNo * 10 - 10;
    // setStart(calcStart);
    // setEnd(pageNo * 10);
    let query = {}
    if (search) {
      query.search = search;
    }
    props.getAllUsersList(
      search,
      searchByUserId,
      phoneNumberSearch,
      { ...dateQuery, page: pageNo, ...query },
      props.auth.user.accessToken,
      onSuccessLoadUsers
    );
    setPage(pageNo);
    //page = pageNo;
  };

  const onSuccessLoadUsers = () => {
    setLoading(false);
  };
  const [search, setSearch] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [isActive, setActive] = useState(false);
  const [stats, setStats] = useState({});
  const [searchByUserId, setSearchByUserId] = useState("");
  const [phoneNumberSearch, setPhoneNumberSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateSearch, setStartDateSearch] = useState("");
  const [endDateSearch, setEndDateSearch] = useState("");
  const [userData, setUserData] = useState([]);

  const pageChangeButtonHandler = (value) => {
    setSelectedTab(value);
  };

  const userFilter = [
    { title: "User Name", disabled: true },
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: "User Activity", disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const onDateChangeHandler = () => (data, type, selected) => {
    setDateQuery(data);
  };

  async function fetchData() {
    let response = await amApi.get(`/userDelete?type=${selectedTab === 0 ? "RETAINED" : "RETAINED_AFTER"}&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`);
    setUserData(response.data)
  }

  async function fetchStats() {
    let response = await amApi.get(`/userDelete?type=STATS&startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`);
    console.log('response.data', response.data)
    setStats(response.data[0])
  }

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      let query = {}
      if (search) {
        query.search = search;
      }
      fetchData()
    }
  }, [dateQuery, search, selectedTab]);

  useEffect(() => {
    fetchStats()
  }, [dateQuery])


  const [filter, setFilter] = useState({
    location: "",
    percentage: "",
    search: false,
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState("");

  // useEffect(() => {
  //   setUserData(props.allUserList);
  // }, [props.allUserList]);

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  // const onChange = async (value) => {
  //   try {
  //     if (value) {
  //       let data = await amApi.get(`/admin/user-service?search=${value}`);
  //       data = data.data;
  //       dispatch({
  //         type: SUPERADMIN_ALL_USER_LIST,
  //         payload: data,
  //       });
  //     }
  //   } catch (err) {
  //     errorAlert('Something went wrong, try again later')
  //   }
  // }

  // const debounceOnChange = useCallback(Debounce(onChange, 1000), []);


  // const downloadData = {
  //   headers: [
  //     { label: "User Name", key: "userName" },
  //     { label: "User Id", key: "userId" },
  //     { label: "Location", key: "location" },
  //     { label: "Seatings", key: "seatings" },
  //     { label: "Orders", key: "orders" },
  //     { label: "Favourites", key: "favs" },
  //     { label: "Scan", key: "scan" },
  //     { label: "Events", key: "events" },
  //     { label: "Reviews", key: "reviews" },
  //     { label: "Profile Completion", key: "profile" },
  //     { label: "Last Activity", key: "lastActivity" },
  //     { label: "Member Since", key: "member" },
  //     { label: "Email", key: "email" },
  //     { label: "Mobile", key: "mobile" },
  //     { label: "status", key: "status" },
  //   ],
  //   data: userData.map((ele) => {
  //     return {
  //       userName: `${ele?.first_name || ""} ${ele?.last_name || ""}`,
  //       userId: ele._id,
  //       location: ele.city || "",
  //       seatings: ele.totaldiner,
  //       orders: ele.totalOrderings,
  //       favs: ele.totalFavs,
  //       scan: ele?.totalScans,
  //       events: ele.totalEvents,
  //       reviews: ele?.totalReviewRating,
  //       profile: ele?.profile_percentage,
  //       lastActivity: `${moment(ele?.updatedAt).format("ll")}`,
  //       member: `${moment(ele?.createdAt).format("ll")}`,
  //       email: ele?.email,
  //       mobile: `${ele?.country_code} ${ele?.mobile_number}`,
  //       status: `${ele?.user_verified ? "verified" : "unverified"}`,
  //     };
  //   }),
  // };

  let filteredData = userData;

  // if (userSort === "A-Z") {
  //   filteredData = filteredData.sort((a, b) => {
  //     if (
  //       a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() <
  //       b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
  //     )
  //       return -1;
  //     if (
  //       a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() >
  //       b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
  //     )
  //       return 1;
  //     return 0;
  //   });
  // } else if (userSort === "Z-A") {
  //   filteredData = filteredData.sort((a, b) => {
  //     if (
  //       a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() <
  //       b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
  //     )
  //       return 1;
  //     if (
  //       a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() >
  //       b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
  //     )
  //       return -1;
  //     return 0;
  //   });
  // } else if (userSort === "Date & Time 🠑") {
  //   filteredData = filteredData.sort(
  //     (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
  //   );
  // } else if (userSort === "Date & Time 🠓") {
  //   filteredData = filteredData.sort(
  //     (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
  //   );
  // }


  // if (filter.location)
  //   filteredData = filteredData.filter((item) => {
  //     return item?.city
  //       ?.toLowerCase()
  //       .includes(filter.location.toLowerCase());
  //   });

  return (
    <>
      {loading ? (
        <AmealioLoader />
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Users" />
              <Col>
                <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    Returning User Report
                  </div>
                </Col>
              </Col>

              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <SelectFilter
                    defaultSelected={props?.history?.location?.state?.back ? props.selectedRange : "TODAY"}
                    onDateChange={onDateChangeHandler()}
                  />
                </div>
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <RightSideCountTop
                    content={[
                      {
                        name: "Re-activation Entry within Threshold Period",
                        value: `${stats?.retained || 0}`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Re-activation Entry after Threshold Period",
                        value: `${stats?.retainedAfter || 0}`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      }]}
                  />
                </div>
                <div className="d-flex justify-content-start mt-3 mb-3">
                  <div className="col-md-6 d-flex align-items-center">
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 0 ? "active" : ""
                        }`}
                      onClick={(e) => pageChangeButtonHandler(0)}
                    >
                      Re-activation Entry within Threshold Period
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 1 ? "active" : ""
                        }`}
                      onClick={(e) => pageChangeButtonHandler(1)}
                    >
                      Re-activation Entry after Threshold Period
                    </Button>
                  </div>
                </div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "25%" }} className="f12-700">
                          User Name/
                          <br /> User ID
                        </th>
                        <th style={{ width: "25%" }} className="f12-700">
                          Email <br /> / Phone
                        </th>
                        <th style={{ width: "25%" }} className="f12-700">
                          Deletion Date <br /> & Time
                        </th>
                        <th style={{ width: "25%" }} className="f12-700">
                          Reason
                        </th>
                      </tr>
                    </thead>
                    {filteredData?.length ? (filteredData.map((user, index) => (
                      <UserModal
                        user={user}
                        key={index}
                        handleShowEdit={(cUser) => handleShowEdit(cUser)}
                      />
                    ))) : <NoContent />}
                  </Table>
                </div>
                {filteredData?.length > 0 ? (
                  <BasicPagination
                    totalRecords={filteredData?.length}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                ) : (
                  <> </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RetainedUsersList
